export class AuthDataState {
  accessToken: string;
  expiredIn: number;
  userName: string;
}
